
const digest = '605167bbf8824600715bda295811698564fe672755e2837b7e6545995af8c3c4';
const classes = {"dayParts":"_dayParts_1m2je_1","times":"_times_1m2je_8","line":"_line_1m2je_15","footer":"_footer_1m2je_21"};
const css = `._dayParts_1m2je_1 {
  display: flex;
  flex-direction: row;
  gap: 30px;
  align-items: center;
}

._times_1m2je_8 {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
}

._line_1m2je_15 {
  width: 2px;
  background-color: #eaedf3;
  height: 55px;
}

._footer_1m2je_21 {
  margin-top: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  